import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-number-only-input',
  templateUrl: './number-only-input.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberOnlyInputComponent),
      multi: true
    }
  ]
})
export class NumberOnlyInputComponent implements ControlValueAccessor {
  @Input() value: any;
  @Input() disabled = false;
  @Input() maxChar: number = 99;
  @Input() isRequired: boolean = false;
  @Input() isEnabled: boolean = true;
  @Input() allowDash = false;
  @Input() allowDot = false;
  @Input() borderless = false;
  @Input() ignoreZero = false;
  @Input() allowEdit = true;

  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  get format() {
    return `^[0-9${this.allowDash ? '-' : ''}${this.allowDot ? '.' : ''}]+$`;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: any): void {
    if (value) {
      this.value = formatNumber(
        this.maxChar,
        this.allowDash,
        this.allowDot,
        value
      );
    } else this.value = '';
    this.onChange(this.value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    if (val)
      this.value = formatNumber(
        this.maxChar,
        this.allowDash,
        this.allowDot,
        val
      );
    else this.value = '';
    this.onChange(this.value);
    this.cdr.markForCheck();
  }

  onKeyUp(event: any) {
    const input = formatNumber(
      this.maxChar,
      this.allowDash,
      this.allowDot,
      event.target.value
    );

    event.target.value = input;
    return false;
  }

  onKeydown(event: any) {
    if (event.ctrlKey || event.metaKey) return;

    const key = `${event.key}`;
    if (key.length !== 1) return;

    const allow =
      (key >= '0' && key <= '9') ||
      (key === '.' && this.allowDot === true) ||
      (key === '-' && this.allowDash === true);
    if (!allow) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent) {
    var clipData = event.clipboardData?.getData('text');

    if (clipData) {
      const formatRegexString = this.format;
      const alphaRegex = new RegExp(formatRegexString);
      var isInvalid = alphaRegex.test(clipData);

      if (isInvalid) event.preventDefault();
    } else {
      event.preventDefault();
    }
  }

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }
}

export function formatNumber(maxChar: number, allowDash: boolean, allowDot: boolean, input: string) {
  let result = '';

  let digitCount = 0;
  for (let c of input) {
    if (c >= '0' && c <= '9' || (c === '-' && allowDash === true) || (c === '.' && allowDot === true)) {
      digitCount++;
      result += c;
      if (maxChar && digitCount === maxChar) return result;
    }
  }
  return result;
}
